import { PeerSelectionStatus, SubmissionStatus, TalkStatus } from "src/common/types";
import { mapTalk } from "src/redux/actions";
import {
  ICancelMyEmployeesTalkAction,
  IGetMyEmployeesAction,
  IGetMyEmployeesActionFulfilled,
  IGetMyEmployeesActionRejected,
  IMyEmployee,
  IMyEmployeesReduxState,
  IReassignMyEmployeesTalkAction,
  IReopenMyEmployeesTalkAction,
  IScheduleMyEmployeesTalkAction
} from "../../types";

const initialState: IMyEmployeesReduxState = {
  completed: false,
  items: [],
  pending: false,
  rejected: false
};

type Action =
  | IGetMyEmployeesAction
  | IGetMyEmployeesActionFulfilled
  | IGetMyEmployeesActionRejected
  | ICancelMyEmployeesTalkAction
  | IScheduleMyEmployeesTalkAction
  | IReassignMyEmployeesTalkAction
  | IReopenMyEmployeesTalkAction;

export default (state = initialState, action: Action): IMyEmployeesReduxState => {
  const { type } = action;
  switch (type) {
    case "REASSIGN_MY_EMPLOYEES_TALK": {
      const { talkId } = action.payload;

      const newItems = state.items
        .map(employee => {
          const reassignedThisEmployee = employee.talks.find(({ id }) => id === talkId);
          // User reasigned, remove from list
          if (reassignedThisEmployee) {
            return null;
          } else {
            return employee;
          }
        })
        .filter(employee => employee) as IMyEmployee[];

      return {
        ...state,
        items: newItems
      };
    }
    case "SCHEDULE_MY_EMPLOYEES_TALK": {
      return {
        ...state,
        items: state.items.map(employee => {
          const { talks } = employee;

          return {
            ...employee,
            talks: talks.map(talk => {
              const { id: talkId } = talk;
              const {
                payload: { talkId: findTalkId, date: newDate }
              } = action;

              if (talkId === findTalkId) {
                return {
                  ...talk,
                  scheduledDate: newDate
                };
              } else {
                return talk;
              }
            })
          };
        })
      };
    }
    case "CANCEL_MY_EMPLOYEES_TALK": {
      return {
        ...state,
        items: state.items.map(employee => {
          const { talks } = employee;

          return {
            ...employee,
            talks: talks.map(talk => {
              const { id: talkId, talkQuestionnaires } = talk;

              if (talkId === action.payload) {
                return {
                  // manually set statuses to CANCEL so the Links appear correctly in myEmployeesPage
                  ...talk,
                  peerSelection: talk.peerSelection
                    ? {
                        ...talk.peerSelection,
                        status: PeerSelectionStatus.Cancelled
                      }
                    : null,
                  scheduledDate: null,
                  status: TalkStatus.Cancelled,
                  talkQuestionnaires: talkQuestionnaires.map(questionnaire => {
                    return {
                      ...questionnaire,
                      submissionStatus: SubmissionStatus.Cancelled
                    };
                  })
                };
              } else {
                return talk;
              }
            })
          };
        })
      };
    }
    case "REOPEN_MY_EMPLOYEES_TALK": {
      const updateTalk = mapTalk(action.payload);
      const { id: talkToUpdate } = updateTalk;

      return {
        ...state,
        items: state.items.map(employee => {
          const { talks } = employee;

          return {
            ...employee,
            talks: talks.map(talk => {
              const { id: talkId } = talk;

              if (talkId === talkToUpdate) {
                return updateTalk;
              } else {
                return talk;
              }
            })
          };
        })
      };
    }
    case "GET_MY_EMPLOYEES_LIST":
      return {
        ...state,
        completed: false,
        items: [],
        pending: true,
        rejected: false
      };
    case "GET_MY_EMPLOYEES_LIST_FULFILLED":
      return {
        ...state,
        completed: true,
        items: action.payload,
        pending: false,
        rejected: false
      };
    case "GET_MY_EMPLOYEES_LIST_REJECTED":
      return {
        ...state,
        completed: true,
        items: [],
        pending: false,
        rejected: true
      };
    default:
      return state;
  }
};
